module.exports = __webpack_public_path__ + "img/pantalla-6-9.880f7962.png";